<template>
  <div class="city-main">
    <div class="left">
      <div class="now-date">
        <p>{{currentMonth}}</p>
        <p>{{currentDate}} {{currentWeek}}</p>
      </div>
    </div>
    <div class="center">
      <!-- <img :src="mapurl" width="100%" /> -->
      <div style="width:100%;height:100%">
        <china-map />
      </div>
    </div>
    <div class="right">
      <!-- 下拉 -->
      <div class="dropdown">
        <span>陕西省</span>
        <select class="city-select" v-model="cityValue">
          <option v-for="item in cityOptions" :key="item" :label="item" :value="item"></option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import chinaMap from "@/components/common/chinaMap";
export default {
  data() {
    return {
      momentInterval: null,
      date: moment(),
      cityValue: "西安",
      cityOptions: [
        "西安",
        "宝鸡",
        "咸阳",
        "渭南",
        "铜川",
        "延安",
        "榆林",
        "汉中",
        "安康",
        "商洛"
      ],
      mapurl: require("../../assets/centermap.png")
    };
  },
  mounted() {
    this.momentInterval = window.setInterval(() => {
      this.date = moment();
    }, 1000);
  },
  computed: {
    currentMonth() {
      return this.date.format("YYYY年MM月DD日");
    },
    currentDate() {
      return this.date.format("HH: mm: ss");
    },
    currentWeek() {
      let week = this.date.day();
      switch (week) {
        case 1:
          return "星期一";
        case 2:
          return "星期二";
        case 3:
          return "星期三";
        case 4:
          return "星期四";
        case 5:
          return "星期五";
        case 6:
          return "星期六";
        case 0:
          return "星期日";
      }
    }
  },
  destroyed() {
    window.clearInterval(this.momentInterval);
  },
  components: {
    chinaMap
  }
};
</script>
<style lang="scss" scoped>
.city-main {
  width: 100%;
  display: flex;
  .left {
    width: 20%;
    .now-date {
      height: 60px;
      width: 160px;
      background: url("../../assets/time_bg.png") no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      line-height: 1.9;
      padding: 5px 15px;
      font-size: 14px;
      font-family: digifaw;
    }
  }
  .center {
    width: 60%;
  }
  .right {
    width: 20%;
    .dropdown {
      height: 30px;
      width: 100%;
      background: url("../../assets/kuang_05.png") no-repeat;
      background-size: 100% 100%;
      padding: 5px 10px;
      font-size: 14px;
      color: #ffffff;
      .city-select {
        margin-left: 20px;
        background-color: rgba(255, 255, 255, 0);
        color: #00ffff;
        border-color: transparent;
        border-bottom-width: 5px;
        :active {
          border-color: transparent;
          border-bottom-width: 2px;
        }
        outline: none;
        option {
          background-color: #0b386d;
          // background: url(../../assets/kuang_06.png);
          border: 1px solid #01cfff;
          margin-top: 2px;
          color: #fff;
          &:active {
            color: #00ffff;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/city.vue